import { Routes } from '@angular/router';
import { AuthGuard } from '@howdeniberia/core-front';
import { FileLibraryInsuranceComponent } from './pages/file-library-insurance/file-library-insurance.component';
import { FileLibraryTemplateComponent } from './pages/file-library-template/file-library-template.component';

export const FileLibraryRoutes = [
  {
    path: 'file-library',
    title: $localize`:@@app.route.file-library:Biblioteca`,
    data: {
      linkText: $localize`:@@app.route.file-library:Biblioteca`
    },
    children: []
  },
  {
    path: 'personal-insurance',
    title: $localize`:@@app.route.file-library.personal-insurance:Seguros Personales`,
    data: {
      icon: 'settings_accessibility',
      linkText: $localize`:@@app.route.file-library.personal-insurance:Seguros Personales`
    },
    children: [
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.life:Vida`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.life:Vida`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.accidents:Accidentes`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.accidents:Accidentes`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.temporary-incapacity:Incapacidad Temporal`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.temporary-incapacity:Incapacidad Temporal`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.healthcare:Asistencia Sanitaria`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.healthcare:Asistencia Sanitaria`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.death:Decesos`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.death:Decesos`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.dependency:Dependencia`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.dependency:Dependencia`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.whole-life:Vida Entera`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.whole-life:Vida Entera`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.personal-insurance.travel-assistance:Asistencia Viaje`,
        data: {
          linkText: $localize`:@@app.route.file-library.personal-insurance.travel-assistance:Asistencia Viaje`
        }
      }
    ]
  },
  {
    path: 'patrimonial-insurance',
    title: $localize`:@@app.route.file-library.patrimonial-insurance:Seguros Patrimoniales`,
    data: {
      icon: 'emoji_transportation',
      linkText: $localize`:@@app.route.file-library.patrimonial-insurance:Seguros Patrimoniales`
    },
    children: [
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.drive:Drive`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.drive:Drive`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.home:Hogar`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.home:Hogar`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.business:Negocios`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.business:Negocios`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.civil-responsibility:Responsabilidad Civil`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.civil-responsibility:Responsabilidad Civil`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.all-risk:Todo Riesgo y Decenal`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.all-risk:Todo Riesgo y Decenal`
        }
      },
      {
        canActivate: [AuthGuard],
        path: 'search/:type',
        component: FileLibraryInsuranceComponent,
        title: $localize`:@@app.route.file-library.patrimonial-insurance.boats:Embarcaciones`,
        data: {
          linkText: $localize`:@@app.route.file-library.patrimonial-insurance.boats:Embarcaciones`
        }
      }
    ]
  },
  {
    path: 'template',
    title: $localize`:@@app.route.file-library.template:Plantillas`,
    data: {
      icon: 'receipt',
      linkText: $localize`:@@app.route.file-library.template:Plantillas`
    },
    children: [
      {
        path: 'search/:type',
        component: FileLibraryTemplateComponent,
        title: $localize`:@@app.route.file-library.template.business-texts:Textos Comerciales`,
        data: {
          linkText: $localize`:@@app.route.file-library.template.business-texts:Textos Comerciales`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryTemplateComponent,
        title: $localize`:@@app.route.file-library.template.sepa:SEPA`,
        data: {
          linkText: $localize`:@@app.route.file-library.template.sepa:SEPA`
        }
      },
      {
        path: 'search/:type',
        component: FileLibraryTemplateComponent,
        title: $localize`:@@app.route.file-library.template.finance:Contrato Financiación`,
        data: {
          linkText: $localize`:@@app.route.file-library.template.finance:Contratos Financiación`
        }
      }
    ]
  }
] as Routes;
